module.exports = __webpack_public_path__ + "img/5.60d02b16.png";